export const LAYERS = {
  dialog: 100050,
  popover: 100100
}
